import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./recruiterReview.css"
import { faAngleRight, faBriefcase, faEnvelope, faNetworkWired, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Tab, Tabs } from 'react-bootstrap';
import { Rating } from '@mui/material';
import ReviewRecComponent from './ReviewRecComponent';
import { apiService } from '../../services/apiService';
function ViewRecruiterReview() {
    const { search } = useLocation();
    const query = new URLSearchParams(search);

    const hasReview = query.has("review");
    const keyName = hasReview ? "review" : null;

    const [activeTab, setActiveTab] = useState( keyName || "profile");
    const { id } = useParams();
    const navigate = useNavigate();
    const [previewData, setPreviewData] = useState([]);
    const [loading, setLoading] = useState(true);
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const fetchPreviewData = useCallback(async () => {
        setLoading(true)
        try {
        const response = await apiService.getRequest(`employee-reviews/${id}`);
        if(response && response.success === true){
            // setPreviewData(Array.isArray(response.data) ? response.data : [response.data]);
            setPreviewData(response.data);
        }else{
            if(response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
        } catch (error) {
        console.error('Error fetching group data:', error);
        }finally{
        setLoading(false)
        }
    }, [id]);

    useEffect(() => {
        fetchPreviewData();
    }, [fetchPreviewData]);

    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <h3>Employee Reviews</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/employee-reviews")}>Employee Reviews</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {previewData && previewData.name}</span>
                </Grid>
                {permissionstest && permissionstest.manage_org_chart === true &&
                <Grid size={{ xs: 12 }} container justifyContent="flex-end" alignItems="center" className="mb-3">
                    <Link to={`/org-chart?${id}`} target='_blank' className='registersendbtn2 my-0 d-flex align-items-center justify-content-center gap-2 text-decoration-none'><FontAwesomeIcon icon={faNetworkWired} /> Org Chat</Link>
                </Grid>}
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className="tab_controllers">
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(key) => setActiveTab(key)}
                            defaultActiveKey="overview"
                            id="uncontrolled-tab-example" className="drafttabs_tabs"
                        >
                            <Tab eventKey="profile" title="Profile">
                                <Grid size={{xs:12}} container className="mt-5">
                                    <Grid size={{xs:12}} container justifyContent="space-between" className="main_shower_viewrecrev">
                                        {previewData && previewData.profile_picture ? 
                                            <img className='profile_imges' src={previewData.profile_picture} alt=''/>:
                                            <img className='profile_imges' src={require("../../assets/defaultprofile.svg").default} alt=''/>
                                        }   
                                        <Grid container justifyContent="space-between" alignContent="space-between" className="widther_recruitereview">
                                            <Grid size={{xs:12}} container justifyContent="space-between" className="order_recriview">
                                                <h5>{previewData.name}</h5>
                                                <div className='d-flex align-items-center gap-3 ratinglabel'>
                                                    <Rating className='rating_spanhiders' disabled  value={previewData.avg_rating} precision={0.5}/>
                                                    <small className='sml_underline'>{previewData.total_reviews} Reviews</small>
                                                </div>
                                            </Grid>
                                            <Grid size={{xs:12}} container justifyContent="space-between" className="order_recriview2 gap-4">
                                                <span>{previewData.job_title || "No Job Title"}</span>
                                                <span><FontAwesomeIcon className='icon_recrev' icon={faPhone} />{previewData.phone_number}</span>
                                                <span><FontAwesomeIcon className='icon_recrev' icon={faEnvelope} />{previewData.email}</span>
                                                <span><FontAwesomeIcon icon={faBriefcase} className='icon_recrev'/>{previewData.experience_months}</span>
                                                {previewData && previewData.linkedin_url &&
                                                <span>
                                                    <a href={`${previewData.linkedin_url}`} target="_blank" rel="noopener noreferrer"><img src={require("../../assets/linkedin-logo-blue.svg").default} alt=''/></a>
                                                </span>}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={{xs:12}} container flexDirection="column" className="bor_content_recview border-0 mt-4">
                                        <h4 style={{color:"#1A5298"}} className='my-4 fw-semibold'>About Me</h4>
                                        <div style={{fontFamily:"unset !important"}} className='w-100 caliberifontsset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(previewData.about || "No Data") }} />
                                    </Grid>
                                </Grid>
                            </Tab>
                            <Tab eventKey="review" title="Review">
                                {activeTab === "review" && <ReviewRecComponent allPreviewData={previewData} onReload={fetchPreviewData}/>}
                            </Tab>
                        </Tabs>
                    </Grid>
                    </>}
            </Grid>
        </div>
    </div>
  )
}

export default ViewRecruiterReview
